import { render } from "./b2cUserFlightDetails.vue?vue&type=template&id=2894522e&scoped=true"
import script from "./b2cUserFlightDetails.vue?vue&type=script&lang=js"
export * from "./b2cUserFlightDetails.vue?vue&type=script&lang=js"

import "./b2cUserFlightDetails.vue?vue&type=style&index=0&id=2894522e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2894522e"]])

export default __exports__